<template>
    <div class="f_box">
        <div class="ct_dy_ymxx">
            <span class="left"><img src="https://www.360ping.com/images/dayin_logo.png"></span>
            <span class="center">【{{ dataInfo.name }}】的{{ dataInfo.courseName }}错题本（{{ chooseIdLi.length }}题）</span>
            <span class="right">你身边的学习助手</span>
        </div>


        <div class="ct_dy_kk">


            <!--xq str  -->
            <div class="cuoti_kk isAddClass1" id="listCont1" style="page-break-after:always;"></div>
            <!--xq end  -->

           
        </div>


        <div class="ct_pr_bn"><button @click="print" type="button" style="font-size: 14px;" class="hui-button hui-button-large hui-primary"><i class="icon iconfont icon-dayinji"></i>确认打印</button></div>
          <!--遮罩层-->
    <div v-if="isLoading " class="loading-overlay">
      <div class="loading-content">
        <div class="loading-spinner"></div>
        <p class="loading-text">数据加载中...</p>
      </div>
    </div>

    </div>
</template>

<script>
import { queryStuWrongQuestionsExam } from "../api/request";

export default {
    components: {},
    props: {},
    data() {
        return {
            dataLi: [],
            dataInfo: {},
            chooseIdLi: [],
            isLoading:true
        };
    },
    watch: {},
    computed: {},
    methods: {
        print(){
            $('.td_tishi').hide()
			/* console.log(123) */
			window.print();
        },
        isObjectiveQuestion(type) {
            return type === 1 || type === 2 || type === 3
        },
        returnFormat(text, h, fontSize) {
            var thisText = $('<div style="visibility: hidden">' + text + '</div>');
            $(document.body).append(thisText);
            fontSize && thisText.find('p').each(function () {
                $(this).css('fontSize', fontSize + 'mm');
            });
            thisText.find('img').each(function () {
                var top = $(this).position().top;
                h && (top += h);
                $(this).css({
                    top: $(this).css('position') !== 'static' ? top : '',
                    verticalAlign: ''
                });
            });
            var str = thisText.html();
            thisText.remove();
            return str;
        },
        srcAddHttp(url) {
            if (!url) {
                return ''
            }
            url = url.replace(/\\/g, "/");
            return !/^https?:\/\//i.test(url) && !/^\//.test(url) ? 'http://' + url : url
        },
        bindResize(el) {

            //初始化参数

            var els = el.style, x = 0, y = 0;
            //鼠标的 X 和 Y 轴坐标

            //邪恶的食指
            $(el).mousedown(function (e) {

                //按下元素后，计算当前鼠标与对象计算后的坐标

                x = e.clientX - el.offsetWidth, y = e.clientY - el.offsetHeight;

                //在支持 setCapture 做些东东

                el.setCapture ? (

                    //捕捉焦点

                    el.setCapture(),

                    //设置事件

                    el.onmousemove = function (ev) {

                        mouseMove(ev || event)

                    },

                    el.onmouseup = mouseUp

                ) : (

                    //绑定事件

                    $(document).bind("mousemove", mouseMove).bind("mouseup", mouseUp)

                )

                //防止默认事件发生

                e.preventDefault()

            });

            //移动事件

            function mouseMove(e) {
                //宇宙超级无敌运算中...
                // els.width = e.clientX - x + 'px', //改变宽度
                    els.height = e.clientY - y + 'px' //改变高度
            }

            //停止事件

            function mouseUp() {

                //在支持 releaseCapture 做些东东

                el.releaseCapture ? (

                    //释放焦点

                    el.releaseCapture(),

                    //移除事件

                    el.onmousemove = el.onmouseup = null

                ) : (

                    //卸载事件

                    $(document).unbind("mousemove", mouseMove).unbind("mouseup", mouseUp)

                )

            }

        }
    },
    created() { },
    mounted() {
        let dataArr = this.$route.query.chooseId.split(',');
        this.chooseIdLi = this.$route.query.chooseId.split(',');
        var printData = ['1', '0', '0', '0'];
        var isAdmin = true, errorNum = 0;
        queryStuWrongQuestionsExam({ examIdStr: this.$route.query.examIdStr, course: this.$route.query.course, stuUserId: this.$route.query.stuUserId, sortType: this.$route.query.sortType, questionTypeIdStr: this.$route.query.questionTypeIdStr, allQues: this.$route.query.allQues }).then((res) => {
            let data = res.data;
            if (res.data.code == 200 && res.data.data) {
                this.dataInfo = res.data.data;
                let oldArr = res.data.data.stuWrongQuestions;
                let newArr = [];

                oldArr.map((item) => {
                    if (dataArr.indexOf(item.id + '') != -1) {
                        newArr.push(item);
                    }
                })
                this.dataLi = newArr;

                var str = '', noErrorArr = '',
                    str2 = '';
                var stuWrongQuestions = data.data.stuWrongQuestions
                if (data.data.name != undefined) {
                    for (let a = 0; a < data.data.stuWrongQuestions.length; a++) {

                        if (data.data.stuWrongQuestions[a].isQues == "") {
                            data.data.stuWrongQuestions[a].title = ''
                        } else {
                            data.data.stuWrongQuestions[a].title = data.data.stuWrongQuestions[a]
                                .title
                        }
                    }
                }
                //$('.cuoTiInfo').html('当前错题数量：<span class="num" style="color: #000">' + stuWrongQuestions.length + '</span>');
                var newStuWrongQuestions = [];
                for (let i = 0; i < stuWrongQuestions.length; i++) {
                    if (noErrorArr && $.inArray(stuWrongQuestions[i].id, noErrorArr) > -1) {
                        continue
                    }
                    var flag = !1;
                    for (var a = 0; a < newStuWrongQuestions.length; a++) {
                        if (newStuWrongQuestions[a].questionId === stuWrongQuestions[i].questionId) {
                            flag = !0;
                            break;
                        }
                    }

                    if (flag) {
                        newStuWrongQuestions[a].answers.push(stuWrongQuestions[i])
                    } else {
                        newStuWrongQuestions.push($.extend(stuWrongQuestions[i], {
                            questionId: stuWrongQuestions[i].questionId,
                            answers: [stuWrongQuestions[i]]
                        }))
                    }
                }
                for (var x = 0; x < noErrorArr.length; x++) {
                    var temp = newStuWrongQuestions.filter(item => item.id != noErrorArr[x][0]);
                    newStuWrongQuestions = temp;
                }
                for (var b = 0; b < newStuWrongQuestions.length; b++) {
                    if(this.chooseIdLi.indexOf(newStuWrongQuestions[b].id.toString())==-1){
                        continue
                    }
                    stuWrongQuestions = newStuWrongQuestions[b].answers || [];
                    var isQues = newStuWrongQuestions[b].isQues === 'true'; //是否是没录入试题
                    var isObjective = this.isObjectiveQuestion(newStuWrongQuestions[b].questionTypeId);
                    var info = newStuWrongQuestions[b].info ? JSON.parse(newStuWrongQuestions[b]
                        .info) : {};
                    var content = null,
                        quesHeight = 0,
                        quesWidth = info.www - 10,
                        newCont = [];
                    if (isQues) {

                        content = newStuWrongQuestions[b].content ? JSON.parse(newStuWrongQuestions[b]
                            .content) : [];
                        for (a = 0; a < content.length; a++) {
                            quesHeight += content[a].h + 25; //手动添加了一个header的固定高度。。2019.5.27 汤佳林
                            var text = content[a].text || content[a].title;
                            text = this.returnFormat(text, quesHeight * pxPerMm, info.fontSize);
                            text && newCont.push(text);

                        }

                    } else {
                        content = newStuWrongQuestions[b].content.replace(/(\r\n|\n)/g, '').split(
                            '</p>');
                        for (a = content.length - 1; a >= 0; a--) {
                            if (!content[a] || /<p[^\nstyle]?[^>]*>[&nbsp;]+$/gi.test(content[a])) {
                                content.splice(a, 0);
                            } else {
                                break
                            }
                        }

                    }
                    /* errorNum++; */
                    /* var knowledgePointStr = newStuWrongQuestions[b].knowledgePointNameStr ?
                        newStuWrongQuestions[b].knowledgePointNameStr.split(',') : []; */

                    var knowledgePointStr = newStuWrongQuestions[b].knowledgePointNameList ?
                        newStuWrongQuestions[b].knowledgePointNameList : [];
                    knowledgePointStr = knowledgePointStr.map(function (value) {
                        return '<span class="xq">' + value + '</span>'
                    });
                    var answerArr = [],
                        rightAnswerArr = [],
                        myAnswerStr = '',
                        analysisStr = '',
                        answerAnalysisStr = '',
                        answerAreaStr = '',
                        noArr = [];
                    for (let i = 0; i < stuWrongQuestions.length; i++) {
                        errorNum++;
                        var superScholarCut = !isObjective ? (stuWrongQuestions[i].superScholarCut ||
                            []) : [];
                        var answerDetail = '';
                        if (isObjective) {
                            var answer = [],
                                rightAnswer = stuWrongQuestions[i].rightAnswer ? stuWrongQuestions[i]
                                    .rightAnswer.split(',') : [];
                            if (stuWrongQuestions[i].questionTypeId !== 3) {
                                answer = stuWrongQuestions[i].myAnswer ? stuWrongQuestions[i].myAnswer
                                    .split(',') : [];
                                var answerStr = [],
                                    rightAnswerStr = [];
                                for (var a = 0; a < answer.length; a++) {
                                    answerStr.push('<span class="d">' + String.fromCharCode(64 +
                                        parseInt(answer[a])) + '</span>');
                                }
                                for (a = 0; a < rightAnswer.length; a++) {
                                    rightAnswerStr.push(String.fromCharCode(64 + parseInt(rightAnswer[
                                        a])));
                                }
                                answerStr = answerStr.join('、') || '漏选';
                                answerArr.push((stuWrongQuestions.length > 1 ? stuWrongQuestions[i]
                                    .no + '题：' : '') + answerStr);
                                rightAnswerStr = rightAnswerStr.join('、');
                                rightAnswerArr.push((stuWrongQuestions.length > 1 ? stuWrongQuestions[
                                    i].no + '题：' : '') + rightAnswerStr)
                            } else {
                                answerArr.push((stuWrongQuestions.length > 1 ? stuWrongQuestions[i]
                                    .no + '题：' : '') + (stuWrongQuestions[i].myScore ===
                                        stuWrongQuestions[i].fullScore ? stuWrongQuestions[i]
                                            .rightAnswer === '1' ? '<span class="d">√</span>' :
                                        '<span class="d">×</span>' : stuWrongQuestions[i]
                                            .rightAnswer === '1' ? '<span class="d">×</span>' :
                                        '<span class="d">√</span>'));
                                rightAnswerArr.push(stuWrongQuestions[i].rightAnswer === '1' ? '√' :
                                    '×');
                            }
                            answerDetail += '<li class="bt" style="padding-left: 0">' + (b + 1 < 10 ?
                                '0' + (b + 1) : b + 1) + '.【参考答案】<span>' + rightAnswerArr.join(
                                    '；') + '</span></li>'
                        } else {
                            rightAnswerArr = [];
                            var cutPath = i === 0 ? stuWrongQuestions[i].cutPath || [] : [],
                                imgStr = '';
                            for (a = 0; a < cutPath.length; a++) {
                                var imgSrc = cutPath[a].split(',');
                                for (var c = 0; c < imgSrc.length; c++) {
                                    imgSrc[c] && (imgStr += '<img src="' + this.srcAddHttp(imgSrc[c]) +
                                        '" alt="" style="display: block">')
                                }
                            }
                            imgStr && answerArr.push('<span class="img">' + imgStr + '</span>');
                            var rightAnswer = stuWrongQuestions[i].rightAnswer,
                                answerImgStr = '';
                            rightAnswer = rightAnswer ? /^http:\/\//i.test(rightAnswer) ? rightAnswer
                                .split(',') : rightAnswer : '';
                            if (typeof rightAnswer !== 'string') {
                                for (a = 0; a < rightAnswer.length; a++) {
                                    answerImgStr += '<img src="' + this.srcAddHttp(rightAnswer[a]) +
                                        '" alt="" style="display: block">'
                                }
                            } else {
                                answerImgStr = rightAnswer;
                            }
                            answerImgStr && rightAnswerArr.push(answerImgStr);
                            answerDetail += '<li class="bt">' + (b + 1 < 10 ? '0' + (b + 1) : b + 1) +
                                '.<span style="color: #000">【参考答案】</span>';
                            if (stuWrongQuestions.length > 1) {
                                noArr.push(stuWrongQuestions[i].no);
                                answerAnalysisStr = rightAnswerArr.length || stuWrongQuestions[i]
                                    .analysis ? ('<li class="jx"><span class="tihh">' +
                                        stuWrongQuestions[i].no + '题</span><br>' +
                                        '<div class="zgt_dda_jx">' + (rightAnswerArr.length ? '答案：' +
                                            rightAnswerArr.join('') + '<br>' : '') +
                                        (stuWrongQuestions[i].analysis ? ('解析：' + stuWrongQuestions[i]
                                            .analysis) : '') +
                                        '</div>' +
                                        '</li>') : ''
                            } else {
                                answerAnalysisStr = '';
                                answerDetail += (!rightAnswerArr.length ? '无' : '') + '</li>' + (
                                    rightAnswerArr.length ? '<li class="da">' + rightAnswerArr
                                        .join('；') + '</li>' : '');
                            }
                        }
                        answerAreaStr += (!isObjective && stuWrongQuestions[i].answerArea ?
                            `<div 
											id="datiquyu${b}" 
											class="s_datiquyu"										    
											style="height:${stuWrongQuestions[i].answerArea * 20}px;">
										<span>
											【${stuWrongQuestions.length > 1 ? stuWrongQuestions[i].no + '题：' : ''}错误订正】											
										</span>
										<div class="btn-move" id="btnMove${b}">
										</div>
										<span class="tz_quyu td_tishi">上下拖动可调整高度</span>
										</div>` : "");

                        analysisStr += answerAnalysisStr + (stuWrongQuestions.length - 1 === i &&
                            superScholarCut.length && printData[3] === '1' ? (
                            '<li class="xbda isAddClass4"><span class="title">【满分示例】</span><span class="img">' +
                            (superScholarCut.map(function (value) {
                                return '<img src="' + value + '" alt="">'
                            }).join('')) + '</span></li>') : '') + (isObjective &&
                                stuWrongQuestions[i].analysis ? '<li class="jx">' + (stuWrongQuestions
                                    .length > 1 ? stuWrongQuestions[i].no + '题：' : '') +
                                stuWrongQuestions[i].analysis + '</li>' : '')

                    }
                    myAnswerStr += (answerArr.length ? printData[1] === '1' ?
                        '<div class="s_nidewuda isAddClass3"><span>【我的误答】</span>' + answerArr
                            .join('；') + '</div>' : '' : '') +
                        (!1 ? '<div class="s_laiyuan"><span><strong>来源：</strong>【' + newStuWrongQuestions[b].examName + (noArr.length ? noArr.join('、') + '题' : '') + '</span></div>' : '');

                    /* 2021-04-15修改去掉序号 */
                    /* (b + 1 < 10 ? '0' + (b + 1) : b + 1) */
                    var newNoArr = [];
                    if (stuWrongQuestions.length > 1) {
                        stuWrongQuestions.forEach(item => {
                            newNoArr.push(item.no);
                        })
                    }
                    

                    printData[0] === '1' && (str +=
                        '<div class="ct_ti_kk"><span class="ti_xh02 nd01">【' +
                        (stuWrongQuestions.length < 2 ? newStuWrongQuestions[b].no + '题' : newNoArr.length ? newNoArr.join('、') + '题' : '') +
                        '】</span>' + '<div class="s_laiyuan02"><span><strong>来源：</strong>【' + newStuWrongQuestions[b].examName + '】' + '</span> ' +
                        (knowledgePointStr.length > 0 ? '<span style="max-width:300px;display:inline-block;margin-left: 10px;display: flex;flex-wrap: wrap;"> <strong>知识点：</strong>' + knowledgePointStr.join('，') + '</span>' : '')
                        + '</div>' +
                        '<div class="ct_ti_xx"><ul><li class="nr"' + (quesHeight ?
                            ' style="position:relative;' + (quesWidth ? 'width:' + quesWidth +
                                'mm;' : '') + 'height:' + quesHeight + 'mm;"' : '') + '>' +
                        newStuWrongQuestions[b].title + (isQues ? newCont.join('') : this.returnFormat(
                            content.join('</p>'))) + '</li></ul></div>' +
                        myAnswerStr +
                        (!1 ? '<div class="ct_ti_sx"><span class="s_left">' + (
                            newStuWrongQuestions[b].difficulty ?
                                '<span style="margin-right: 10px">难度：<font>' + difficulty[
                                newStuWrongQuestions[b].difficulty] + '</font></span>' : '') +
                            '<span>我的得分率：<font>' + parseFloat((newStuWrongQuestions[b].myScore /
                                newStuWrongQuestions[b].fullScore * 100).toFixed(2)) +
                            '%<i>(<b style="color: #000">' + newStuWrongQuestions[b].myScore +
                            '</b>/' + newStuWrongQuestions[b].fullScore +
                            '分)</i></font></span></span></div>' : '') +
                        answerAreaStr +
                        '</div>');
                        
                    /* printData[2] === '1' && (str2 += '<div class="ct_da_xq"><ul>' + answerDetail +
                        analysisStr + (knowledgePointStr.length > 0 ? '<li class="zsdxx">知识点：' +
                            knowledgePointStr.join(' ') + '</li>' : '') + '</ul></div>'); */
                }
                
            } else {
                str = '<div class="in_no_ks">' +
                    '<span class="tspic"><img src="../images/noxx02.png" alt=""></span>' +
                    '<span class="tswz">未查询到相关数据</span>' +
                    '</div>'
            }
            this.isLoading=false
            $('.title').text((!isAdmin ? '【' + data.data.name + '】的' : '') + data.data.courseName +
                '错题本' + (!isAdmin ? '' : '预览') + '（' + errorNum + '题）');

                console.log(str,123);
            $('#listCont1').html(str);
            str2 ? $('#listCont2').html(str2) : $('#listCont2').parent().remove();
            /* $('.s_datiquyu').bind("mousedown", mouseDown); */
            // $('.s_datiquyu').l_zoom('auto');
            typeof MathJax === 'object' && MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
            this.$nextTick(() => {
                let arr=document.getElementsByClassName('s_datiquyu');
                for (let i = 0; i < arr.length; i++) {
                    this.bindResize(arr[i]);
                }
                
            })



        })

    }
};
</script>
<style lang="less" scoped>
/deep/ul{
    list-style: none;
    padding: 0;
    margin: 0;
}
/deep/ .cuoti_kk {
    padding: 0px 0px 5px 0px;
}

/deep/ .ct_ti_kk {
    margin-top: 10px;
    margin-bottom: 10px;
    background-color: #fff;
    border: 1px solid #bbb;
    display: block;
    clear: both;
    border-radius: 5px;
    position: relative;
}

/deep/.ct_ti_kk button.ti_jc_bn {
    position: absolute;
    right: 4px;
    top: 4px;
}

/deep/.ct_ti_kk button.ti_jc_bn:hover {
    background-color: #d9534f;
    color: #fff;
    border: 1px solid #d9534f;
}

/deep/.ct_ti_kk span.ti_xh {
    display: inline-block;
    background-color: #1abb9c;
    border: 1px solid #1abb9c;
    position: absolute;
    top: -10px;
    border-radius: 0px 5px 5px 0px;
    left: -2px;
    height: 20px;
    min-width: 25px;
    text-align: center;
    line-height: 20px;
    color: #fff;
    padding-left: 0px;
    padding-right: 5px;
    cursor: pointer;
}

/deep/.ct_ti_kk span.ti_xh02 {
    display: inline-block;
    background-color: #1abb9c;
    border: 1px solid #1abb9c;
    position: absolute;
    top: 0px;
    border-radius: 0px 0px 5px 0px;
    left: 0px;
    height: 20px;
    min-width: 20px;
    text-align: center;
    line-height: 20px;
    color: #fff;
    padding-left: 0px;
    padding-right: 0px;
    font-size: 12px;
}

/deep/.ct_ti_kk span.no {
    background-color: #999;
    border: 1px solid #ccc;
}



/deep/.ct_ti_kk span.ti_xz {
    position: absolute;
    top: 0px;
    right: 0px;
    padding: 2px 3px 5px 25px;
    cursor: pointer;
}

/deep/.ct_ti_kk span.ti_xz i {
    font-size: 20px;
}

/deep/.ct_ti_kk span.ti_xz i.yx {
    color: #54b047;
}

/deep/.ct_ti_kk span.ti_xz i.wx {
    color: #cccccc;
}

/deep/.ct_ti_kk .shiti_fen {
    position: absolute;
    right: 10px;
    top: 10px;
}

/deep/.ct_ti_kk .shiti_fen font {
    color: #F00;
    padding-left: 0px;
}

/deep/.ct_ti_kk .s_laiyuan02 {
    position: absolute;
    right: 10px;
    top: 0px;
}

/deep/.ct_ti_kk .s_laiyuan02 span {
    color: #333333;
    font-size: 12px;
    padding-left: 0px;
}

/deep/.ct_ti_jx {
    display: block;
    clear: both;
    overflow: hidden;
    border: #1abb9c 1px solid;
    position: relative;
}

/deep/.ct_ti_jx ul {
    display: block;
    clear: both;
}

/deep/.ct_ti_jx ul li.j_left {
    width: 23%;
    float: left;
    line-height: 25px;
    text-align: right;
    padding-top: 5px;
    padding-bottom: 5px;
    color: #333;
    font-size: 12px;
}

/deep/.ct_ti_jx ul li.j_left span.zt_lv {
    color: #090;
}

/deep/.ct_ti_jx ul li.j_right {
    width: 76%;
    float: right;
    line-height: 25px;
    padding-right: 3px;
    text-align: left;
    padding-top: 5px;
    padding-bottom: 5px;
    font-size: 12px;
}

/deep/.ct_ti_jx ul li.j_right span.bg_lv {
    background-color: #090 !important;
}

/deep/.ct_ti_jx ul li.j_right span.hui-badge {
    font-size: 12px;
}

/deep/.ct_ti_jx ul li.j_right img {
    max-width: 100%;
    display: inline-block;
}

/deep/.ct_ti_jx ul.mfsl li {
    display: block;
    clear: both;
    width: 100%;
}

/deep/.ct_ti_jx ul.mfsl li.j_left {
    text-align: left;
}

/deep/.ct_ti_jx ul.mfsl li.j_left span {
    padding-left: 10px;
    font-size: 12px;
}

/deep/.ct_ti_jx ul.mfsl li.j_right {
    text-align: center;
}

/deep/.ct_ti_jx ul.mfsl li.j_right img {
    max-width: 96%;
}

/deep/.ct_ti_jx ul li.xh {
    font-size: 12px;
    padding-left: 10px;
    border-top: 1px #ccc dashed;
    line-height: 22px;
}

/deep/.ct_ti_jx ul li.xh02 {
    font-size: 12px;
    padding-left: 15px;
    line-height: 22px;
}



/deep/.ct_ti_sx {
    background-color: #efefef;
    border-top: 1px solid #ddd;
    line-height: 35px;
    height: 35px;
    position: relative;
}

/deep/.ct_ti_sx span.s_left {
    float: left;
    padding-left: 10px;
}

/deep/.ct_ti_sx span.s_left span {
    padding-right: 2px;
    padding-left: 2px;
    font-size: 12px;
}

/deep/.ct_ti_sx span.s_left span .iconfont {
    font-size: 14px;
}

/deep/.ct_ti_sx span.s_left span.zw {
    color: #f39c12;
}

/deep/.ct_ti_sx span.s_left span.zw .icon-shoucang3 {
    color: #f39c12;
    font-size: 12px;
}



/deep/.ct_ti_sx span.s_left span font {
    padding-right: 5px;
    padding-left: 5px;
    color: #039;
    font-size: 12px;
}

/deep/.ct_ti_sx span.s_left span font i {
    padding-left: 5px;
    font-size: 12px;
}

/deep/.ct_ti_sx span.s_left span font i b {
    color: #F00;
    font-size: 14px;
}

/deep/.ct_ti_sx span.s_right {
    float: right;
    padding-right: 10px;
    font-size: 12px;
}

/deep/.ct_ti_sx span.s_right i {
    padding-right: 5px;
}

/deep/.ct_ti_sx span.s_right span.btjx {
    display: inline-block;
    padding-right: 10px;
    padding-left: 10px;
    position: absolute;
    top: -2px;
    bottom: 0px;
    z-index: 10;
    right: 15px;
    line-height: 35px;
    background-color: #00aeff;
    border-top: 1px solid #fff;
    color: #FFF;
}

/deep/.ct_ti_sx span.s_right span.btjx i {
    color: #FFF;
}

/deep/.ct_ti_sx span.s_right span.btjx:hover {
    background-color: #fff;
    cursor: pointer;
    color: #222;
}

/deep/.ct_ti_sx span.s_right span.btjx:hover i {
    color: #222;
}

/deep/.ct_ti_sx span.s_right span.active {
    display: inline-block;
    padding-right: 10px;
    padding-left: 10px;
    position: absolute;
    top: -2px;
    bottom: 0px;
    z-index: 10;
    right: 15px;
    background-color: #FFFFFF;
    border: #1abb9c 1px solid;
    border-top: none;
    line-height: 35px;
    color: #1abb9c;
}

/deep/.ct_ti_sx span.s_right span {
    font-size: 12px;
}

/deep/.ct_ti_xx {
    padding: 15px 10px 10px 10px;
}

/deep/.ct_ti_xx ul li.bt {
    line-height: 25px;
    color: #000;
    border-bottom: 1px solid #e5e5e5;
    font-size: 14px;
    padding-left: 3px;
}

/deep/.ct_ti_xx ul li.nr {
    line-height: 6.5mm;
    color: #000;
    margin-top: 5px;
    font-size: 14px;
}

/deep/.ct_ti_xx ul li.nr img {
    max-width: 100%;
    position: static !important;
    vertical-align: middle !important;
}

/deep/.ct_ti_xx ul li.nr p {
    line-height: 6.5mm;
    font-size: 14px;
    font-family: "å®‹ä½“";
    text-align: justify;
    word-wrap: break-word;
}

/deep/.ct_ti_xx ul li.nr u {
    line-height: 6.5mm;
    font-size: 14px;
}

/deep/.ct_ti_xx ul li.nr font {
    font-size: 14px;
    font-family: "å®‹ä½“";
}

/deep/.ct_ti_xx ul li.nr li span {
    font-size: 14px;
    font-family: "å®‹ä½“";
}

/deep/.ct_ti_xx ul li.nr table {
    border: 1px solid #000000;
    border-collapse: collapse
}


/* /deep/.ct_ti_xx ul li.nr span.heavy {position: relative;display: inline-block!important;line-height: 1.42857143!important;}*/
/deep/.ct_ti_xx ul li.nr span.heavy:after {
    position: absolute;
    top: 1em;
    left: 0em;
    font-family: "NSimSun";
}


/deep/.ct_ti_xx ul li.ly {
    text-align: right;
    border-top: 1px solid #efefef;
    padding-top: 5px;
    font-size: 11px;
}

/deep/.ct_ti_xx ul li.ly span.ti {
    color: #060;
    font-size: 11px;
}

/deep/.ct_ti_xx ul li.da {
    text-align: left;
    border-top: 1px solid #efefef;
    padding-top: 10px;
    padding-bottom: 10px;
}

/deep/.ct_ti_xx ul li.da span.d {
    color: #d00;
    font-size: 12px;
}

/deep/.ct_ti_xx ul li.da {
    color: #000000;
    font-size: 12px;
}

/deep/.ct_ti_xx ul li.da span.bt {
    display: block;
    clear: both;
    color: #000000;
    line-height: 35px;
    font-size: 12px;
}

/deep/.ct_ti_xx ul li.da img {
    max-width: 100%;
}

/deep/.ct_ti_xx ul li.zsdxx {
    text-align: left;
    border-top: 1px solid #efefef;
    padding-top: 10px;
}

/deep/.ct_ti_xx ul li.zsdxx span.xq {
    background-color: #9bc5ff;
    padding: 3px 10px 3px 10px;
    border-radius: 10px;
    color: #000;
}

/deep/.ct_ti_xx ul li span.bg_lv {
    background-color: #90b283 !important;
}

/deep/.nr img {
    height: auto;
}

/deep/#layui-layer-content {
    line-height: 24px;
    word-break: break-all;
    padding: 20px;
    min-width: 300px;
    overflow: hidden;
    overflow-y: auto;
}

/deep/.hui-wrap {
    max-width: 90%;
}

/deep/p:empty {
    display: none;
}

/deep/.ct_ti_xx ul li.nr img {
    vertical-align: middle;
}

/deep/.s_datiquyu {
    position: relative !important;
}

/deep/.s_datiquyu:hover {
    border-bottom: 2px dashed #f00;
}

/deep/.s_datiquyu:hover .td_tishi {
    display: block;
}

/deep/.btn-move {
    height: 5px;
    width: 98%;
    cursor: n-resize;
    position: absolute;
    bottom: 0;
    border: 1px dashed transparent;
    border-bottom: 1px dashed #efefef;
}

/deep/.tz_quyu {
    font-size: 12px !important;
    color: #ff0000;
    position: absolute;
    right: 5px;
    bottom: 5px;
}

/deep/.ct_ti_kk span.ti_xh02 {
    display: inline-block;
    position: absolute;
    background-color: #fff;
    border: 1px solid #fff;
    top: 0px;
    border-radius: 0px 0px 5px 0px;
    left: 0px;
    height: 20px;
    min-width: 20px;
    text-align: center;
    line-height: 20px;
    color: #333;
    padding-left: 0px;
    padding-right: 0px;
    font-size: 14px;
    font-weight: bold;
}

/deep/.ct_ti_kk .s_laiyuan02 {
    display: flex;
}

/deep/.cuoti_kk {
    padding: 0px 0px 5px 0px;
}

/deep/.ct_ti_kk {
    margin-top: 10px;
    margin-bottom: 10px;
    background-color: #fff;
    border: 1px solid #bbb;
    display: block;
    clear: both;
    border-radius: 5px;
    position: relative;
}

/deep/.ct_ti_kk button.ti_jc_bn {
    position: absolute;
    right: 4px;
    top: 4px;
}

/deep/.ct_ti_kk button.ti_jc_bn:hover {
    background-color: #d9534f;
    color: #fff;
    border: 1px solid #d9534f;
}

/deep/.ct_ti_kk span.ti_xh {
    display: inline-block;
    background-color: #1abb9c;
    border: 1px solid #1abb9c;
    position: absolute;
    top: -10px;
    border-radius: 0px 5px 5px 0px;
    left: -2px;
    height: 20px;
    min-width: 25px;
    text-align: center;
    line-height: 20px;
    color: #fff;
    padding-left: 0px;
    padding-right: 5px;
    cursor: pointer;
}

/deep/.ct_ti_kk span.ti_xh02 {
    display: inline-block;
    position: absolute;
    top: 0px;
    border-radius: 0px 0px 5px 0px;
    left: 0px;
    height: 20px;
    min-width: 20px;
    text-align: center;
    line-height: 20px;
    color: #333;
    padding-left: 0px;
    padding-right: 0px;
    font-size: 14px;
    font-weight: bold;
}

/deep/.ct_ti_kk span.no {
    background-color: #999;
    border: 1px solid #ccc;
}



/deep/.ct_ti_kk span.ti_xz {
    position: absolute;
    top: 0px;
    right: 0px;
    padding: 2px 3px 5px 25px;
    cursor: pointer;
}

/deep/.ct_ti_kk span.ti_xz i {
    font-size: 20px;
}

/deep/.ct_ti_kk span.ti_xz i.yx {
    color: #54b047;
}

/deep/.ct_ti_kk span.ti_xz i.wx {
    color: #cccccc;
}

/deep/.ct_ti_kk .shiti_fen {
    position: absolute;
    right: 10px;
    top: 10px;
}

/deep/.ct_ti_kk .shiti_fen font {
    color: #F00;
    padding-left: 0px;
}

/deep/.ct_ti_kk .s_laiyuan02 span {
    color: #333333;
    font-size: 12px;
    padding-left: 0px;
}



/deep/.ct_dy_kk {
    max-width: 200mm;
    margin: 0px auto;
    background-color: #ffffff;
    margin-top: 10px;
    margin-bottom: 80px;
}

/deep/.ct_dy_kk div.ct_ti_xx li.nr {
    font-size: 14px;
    line-height: 25px;
}

/deep/.ct_dy_kk div.ct_ti_xx li p {
    font-size: 14px;
}

/deep/.ct_dy_kk div.ct_ti_xx li.nr p {
    font-size: 14px;
}

/deep/.ct_dy_kk div.ct_ti_xx li.nr font {
    font-size: 14px;
}

/deep/.ct_dy_kk div.ct_ti_xx li.nr li span {
    font-size: 14px;
}

/deep/.ct_dy_kk div.s_laiyuan span {
    color: #000;
}

/deep/.ct_dy_kk div.s_nidewuda {
    font-size: 16px;
}

/deep/.ct_dy_kk div.s_nidewuda span {
    font-size: 14px;
}

/deep/.ct_dy_kk div.ct_ti_sx span {
    font-size: 12px;
    padding-right: 10px;
}

/deep/.ct_dy_kk div.ct_ti_sx span font {
    font-size: 12px;
    color: #000;
}

/deep/.ct_dy_kk div.ct_ti_sx span font i {
    font-style: normal;
}

/deep/.ct_dy_kk div.ct_da_title {
    font-size: 16px;
}

/deep/.ct_dy_kk div.ct_da_xq li.bt,
/deep/.ct_dy_kk div.ct_da_xq li.bt span,
/deep/.ct_dy_kk div.ct_da_xq li.jx {
    font-size: 14px;
    line-height: 25px;
}

/deep/.ct_dy_kk div.ct_da_xq ul li.xbda span {
    font-size: 14px;
}


/deep/.ct_dy_ymxx {
    display: block;
    clear: both;
    text-align: center;
    border-bottom: 1px solid #888888;
    margin-bottom: 10px;
    padding-bottom: 15px;
    padding-top: 10px;
    line-height: 30px;
}

/deep/.ct_dy_ymxx span.left {
    position: absolute;
    left: 10px;
}

/deep/.ct_dy_ymxx span.left img {
    height: 35px;
}

/deep/.ct_dy_ymxx span.center {
    font-size: 20px;
}

/deep/.ct_dy_ymxx span.right {
    position: absolute;
    right: 10px;
    top: 15px;
    font-size: 13px;
}








/deep/.ct_ti_xx {
    padding: 15px 10px 10px 10px;
}

/deep/.ct_ti_xx ul li.bt {
    line-height: 25px;
    color: #000;
    border-bottom: 1px solid #e5e5e5;
    font-size: 14px;
    padding-left: 3px;
}

/deep/.ct_ti_xx ul li.nr {
    line-height: 6.5mm;
    color: #000;
    margin-top: 5px;
    font-size: 14px;
    position: relative;
}

/deep/.ct_ti_xx ul li.nr img {
    max-width: 100%;
    position: static !important;
    vertical-align: middle !important;
}


/deep/.ct_ti_xx ul li.nr p {
    line-height: 180% !important;
    font-size: 14px;
    font-family: "Times New Roman";
    text-align: justify;
    word-wrap: break-word;
}

/deep/.ct_ti_xx ul li.nr u {
    line-height: 180%;
    font-size: 14px;
    font-family: "瀹嬩綋";
}

/deep/.ct_ti_xx ul li.nr font {
    font-size: 14px;
    font-family: "瀹嬩綋";
}

/deep/.ct_ti_xx ul li.nr li span {
    font-size: 14px;
    font-family: "瀹嬩綋";
}

/deep/.ct_ti_xx ul li.nr table {
    border: 1px solid #000000;
    border-collapse: collapse
}


/* /deep/.ct_ti_xx ul li.nr span.heavy {position: relative;display: inline-block!important;line-height: 1.42857143!important;}*/
/deep/.ct_ti_xx ul li.nr span.heavy:after {
    position: absolute;
    top: 1em;
    left: 0em;
    font-family: "NSimSun";
}


/deep/.ct_ti_xx ul li.ly {
    text-align: right;
    border-top: 1px solid #efefef;
    padding-top: 5px;
    font-size: 11px;
}

/deep/.ct_ti_xx ul li.ly span.ti {
    color: #060;
    font-size: 11px;
}

/deep/.ct_ti_xx ul li.da {
    text-align: left;
    border-top: 1px solid #efefef;
    padding-top: 10px;
    padding-bottom: 10px;
}

/deep/.ct_ti_xx ul li.da span.d {
    color: #d00;
    font-size: 12px;
}

/deep/.ct_ti_xx ul li.da {
    color: #000000;
    font-size: 12px;
}

/deep/.ct_ti_xx ul li.da span.bt {
    display: block;
    clear: both;
    color: #000000;
    line-height: 35px;
    font-size: 12px;
}

/deep/.ct_ti_xx ul li.da img {
    max-width: 100%;
}

/deep/.ct_ti_xx ul li.zsdxx {
    text-align: left;
    border-top: 1px solid #efefef;
    padding-top: 10px;
}

/deep/.ct_ti_xx ul li.zsdxx span.xq {
    background-color: #9bc5ff;
    padding: 3px 10px 3px 10px;
    border-radius: 10px;
    color: #000;
}

/deep/.ct_ti_xx ul li span.bg_lv {
    background-color: #90b283 !important;
}

/deep/.ct_ti_xx ul li span.bg_lan01 {
    background-color: #c1dbff !important;
}

/deep/.ct_ti_xx ul li span {
    margin-bottom: 5px;
}


/deep/.s_datiquyu {
    display: block;
    clear: both;
    border: 1px dashed #ccc;
    margin: 4px 10px 4px 10px;
    padding: 5px;
}

/deep/.s_datiquyu:hover {
    border-bottom: 2px dashed #f00;
}

/deep/.s_datiquyu span {
    padding: 0px;
    font-size: 14px;
}

.f_box {
    font-family: '宋体', serif;
}


/deep/.s_datiquyu span.tz_quyu {
    font-size: 12px;
    color: #ff0000;
    position: absolute;
    right: 15px;
    bottom: 10px;
}

.ct_pr_title {
    text-align: center;
    font-size: 18px;
}

.ct_pr_bn {
    text-align: center;
    width: 100%;
    margin: 0px auto;
    margin-bottom: 0px;
    position: fixed;
    bottom: 0px;
    left: 0px;
    right: 0px;
    background-color: #efefef;
    border-top: 1px solid #dfdfdf;
    padding-top: 10px;
    padding-bottom: 10px;
}

.ct_pr_bn button {
    cursor: pointer;
    min-width: 100px;
    margin: 0px auto;
    padding: 5px 10px;
    background-color: #2189d0;
    color: #fff;
    border-radius: 5px;
    border: none;
}

.ct_pr_bn button:hover {
    background-color: #090;
}

.ct_pr_bn button .icon {
    padding-right: 5px;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #fff;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loading-text {
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/cuoti_print.vue